// src/hooks/useRole.ts

import { useAuthStore } from "../store/authStore";

export const useRole = () => {
  const role = useAuthStore((s) => s.user?.role) ?? null;

  return {
    role,
    isAdmin:     role === 'admin',
    isStaff:     role === 'staff',
    isPrincipal: role === 'principal',
    isTeacher:   role === 'teacher',
  };
};